import React, { useContext } from 'react';
import { PapiDeviationBackground } from '@wix/da-papi-types';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { StageBackgroundProps } from '../types';
import { BackgroundVariant } from '../../redux/types';
import {
  ThemeContext,
  ThemeSkinContext,
} from '@wix/da-react-context/pkg/ThemeContext';
import { getBackgroundVariant } from '../../redux/helpers';

const LARGE_BACKGROUND_MIN_SIZE = 1300;

function pickBackgroundSrc(
  {
    darkBigUrl,
    darkSmallUrl,
    lightBigUrl,
    lightSmallUrl,
    greenBigUrl = lightBigUrl,
    greenSmallUrl = lightSmallUrl,
  }: PapiDeviationBackground,
  variant: BackgroundVariant,
  width?: number
) {
  const useLarge = width && width > LARGE_BACKGROUND_MIN_SIZE;

  switch (variant) {
    case 'green':
      return useLarge ? greenBigUrl : greenSmallUrl;
    case 'light':
      return useLarge ? lightBigUrl : lightSmallUrl;
    case 'dark':
    default:
      return useLarge ? darkBigUrl : darkSmallUrl;
  }
}

const DefaultStageBackground: React.FC<StageBackgroundProps> = ({
  width,
  deviation,
  background = deviation.background || 'default',
}) => {
  const isMobile = useContext(MobileContext);
  const theme = useContext(ThemeContext);
  const themeSkin = useContext(ThemeSkinContext);

  if (background === 'default' || isMobile) {
    return <EmptyBackground />;
  }

  return (
    <BackgroundImage
      src={pickBackgroundSrc(
        background,
        getBackgroundVariant(theme, themeSkin),
        width
      )}
    />
  );
};
DefaultStageBackground.displayName = 'DefaultStageBackground';
export default DefaultStageBackground;
